<template>
    <div id="customQuotes" class="mt-6">

        <div class="border-t-2 border-blue-600">
            <div class="tan-control-box pb-1 flex flex-wrap">
                <div class="xs:w-full sm:w-full md:w-auto" v-if="section === 'futures'">
                    <div class="flex flex-wrap">
                        <div class="font-bold mb-1 mr-2 self-center">SELECT:</div>
                        <contract-selector v-model="symbol" :all-contracts="sectionQuotes.futures" />
                        <div class="w-auto ml-1 text-center align-top flex justify-center md:inline-flex md:justify-start mb-1">
                            <div @click="addSymbol" class="btn btn-yellow btn-sm self-center">Add Futures Quote</div>
                        </div>
                    </div>
                </div>
                <div class="sm:w-full xs:w-full md:w-auto" v-if="section === 'future-options'">
                    <div class="flex flex-wrap">
                        <div class="font-bold mb-1 mr-2 self-center">SELECT:</div>
                        <option-selector-2 v-model="symbol" :groups="sectionQuotes.options" />
                        <div class="w-auto align-top flex justify-center md:justify-start mb-1">
                            <div @click="addSymbol" class="btn btn-yellow btn-sm self-center">Add Futures Options Quote</div>
                        </div>
                    </div>
                </div>
                <div class="sm:w-full xs:w-full md:w-auto" v-if="section === 'forex'">
                    <div class="flex flex-wrap" id="selectForex">
                        <div class="font-bold mb-1 mr-2 self-center">SELECT:</div>
                        <forex-selector v-model="symbol" :symbols="sectionQuotes.forex" />
                        <div class="w-auto ml-1 text-center align-top flex justify-center sm:inline-flex sm:justify-start mb-1">
                            <div @click="addSymbol" class="btn btn-yellow btn-sm self-center">Add Forex Quote</div>
                        </div>
                    </div>
                </div>
                <div class="sm:w-full xs:w-full md:w-auto relative" v-if="section === 'stock-etf'">
                    <div class="flex flex-wrap">
                        <div class="font-bold mb-1 mr-2 self-center">SELECT:</div>
                        <stock-search-selector v-model="symbol" ref="stockSelectorRef"></stock-search-selector>
                        <div class="w-auto ml-1 text-center align-top flex justify-center sm:inline-flex sm:justify-start mb-1">
                            <div @click="addSymbol" class="btn btn-yellow btn-sm self-center">Add Stocks & ETFs Quote</div>
                        </div>
                    </div>
                </div>
                <div class="sm:w-full xs:w-full md:w-auto" v-if="section === 'future-spreads'">
                    <div class="font-bold mb-1 mr-2 self-center">SELECT:</div>
                    <div class="flex flex-wrap" id="selectFutureSpreads">
                        <spread-selector v-model="symbol" :spreads="sectionQuotes.spreads" :all-contracts="sectionQuotes.futures" />
                        <div class="w-full md:w-auto ml-0 md:ml-2 text-center align-top flex lg:inline-flex mt-1 md:mt-0 mb-3">
                            <div @click="addSymbol" class="btn btn-yellow btn-sm self-center">Add Spread Quote</div>
                        </div>
                    </div>
                </div>
                <div class="sm:w-full xs:w-full md:w-auto" v-if="section === 'crypto'">
                    <div class="flex flex-wrap" id="selectCrypto">
                        <div class="font-bold mb-1 mr-2 self-center">SELECT:</div>
                        <forex-selector v-model="symbol" :symbols="sectionQuotes.crypto" />
                        <div class="w-auto ml-1 text-center align-top flex justify-center sm:inline-flex sm:justify-start mb-1">
                            <div @click="addSymbol" class="btn btn-yellow btn-sm self-center">Add Crypto Quote</div>
                        </div>
                    </div>
                </div>
                <div class="w-full lg:w-auto ml-auto mb-2">
                    <div @click="addBlankRow" class="btn btn-sm btn-yellow-ghost mt-2 sm:mt-0 ml-1 inline-block">Add Blank Row</div>
                </div>
            </div>
            <custom-quotes-table
                ref="tableRef"
                :title="title"
                :section="legacySection"
                :initial-items="quotes">
            </custom-quotes-table>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import CustomQuotesTable from './CustomQuotesTable';

const props = defineProps({
    sectionQuotes: [Object, Array],
    section: String,
    legacySection: String,
    searchService: String,
    quotes: Array,
    title: String
});

const symbol = ref(null);
const tableRef = ref(null);
const stockSelectorRef = ref(null);

const addSymbol = () => {
    if (symbol.value === null) return;

    getTitle()
        .then((title) => {
            tableRef.value.addItem({ symbol: symbol.value, title });
            if (props.section === 'stock-etf') {
                stockSelectorRef.value.selectFirst();
            }
        });

};

const addBlankRow = () => {
    tableRef.value.addItem({
        blankRow: true,
        symbol: `~`
    });
};

const getTitle = () => {
    const route = window.route('api.quotes');

    return axios.post(route, {
        symbol: symbol.value,
        fields: 'symbolName,symbolType,symbol,contractMonthYear',
        after: 'getChartTitle'
    })
    .then((response) => {
        return response.data.data[0].title;
    }).catch(error => {
        console.error(error);
    });
};
</script>

<style lang="scss">
#customQuotes {
    .form-control {
        @apply mb-1;
    }
    .btn-table-action {
        @apply ml-1;
    }
    #selectForex,
    #selectCrypto {
        select {
            width: 100%;
        }
    }
    #selectFutureSpreads {
        & > span {
            display: flex;
            flex-wrap: wrap;
        }
        select {
            width: 100%;
        }
    }
}
</style>
